




















































































import Vue from 'vue'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import ProgressCircular from '@/components/ProgressCircular.vue'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping,
  DxGroupPanel,
  DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import { hexToRgba } from '@/services/hex-to-rgba'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { KeyAction } from '@/model/KeyAction'
import { keyActionService } from '@/services/key-action-service'
import { ConfigurationDescriptionLanguage, UiLanguageItem, UiLanguageList } from '@/types'
import DescriptionLanguagesDialog from '@/components/settings/configuration/DescriptionLanguagesDialog.vue'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}
class Save extends KeyAction {}
class Cancel extends KeyAction {}

interface ComponentData {
  rules: Function[]
  loading: boolean
  saveLoading: boolean
  showSnackbar: boolean
  messageSnackbar: string
  snackbarState: number
  showDeleteDialog: boolean
  showDescriptionLanguagesDialog: boolean

  isEdit: boolean

  tableHeight: string
  selectedConfigurationIndex: number | null
  selectedConfiguration: any | null
  configurationList: any[]

  code: string | null
  bezeichnung: string | null
  rtf: boolean
  languagesDialogDescriptionData: ConfigurationDescriptionLanguage[],

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'ConfigurationForm145',

  components: {
    ProgressCircular,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    DeleteDialog,
    DescriptionLanguagesDialog
  },

  props: {
    formData: Array as () => any[]
  },

  data (): ComponentData {
    return {
      rules: [(value: any): boolean | string => !!value || this.$t('masterData.shifts.required').toString()],
      loading: false,
      saveLoading: false,
      showSnackbar: false,
      messageSnackbar: '',
      snackbarState: 0,
      showDeleteDialog: false,
      showDescriptionLanguagesDialog: false,

      isEdit: false,

      tableHeight: '',
      selectedConfigurationIndex: null,
      selectedConfiguration: null,
      configurationList: [],

      code: null,
      bezeichnung: null,
      rtf: false,
      languagesDialogDescriptionData: [],

      keyActions: []
    }
  },

  watch: {
    isEdit (newVal: boolean): void {
      if(newVal) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      } else {
        setTimeout(() => {
          const focusedButton: any = this.$refs['focusedButton']
          if (focusedButton) {
            focusedButton.$el.focus()
          }
        }, 0)
      }
    },

    bezeichnung (newVal: string | null): void {
      let foundText: ConfigurationDescriptionLanguage | undefined = this.languagesDialogDescriptionData.find((item: ConfigurationDescriptionLanguage) => item.languageId === this.selectedLanguageId)
      if(foundText) {
        foundText.text =  newVal ? newVal : ''
      }
    },
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    isDisabledInsertButton (): boolean {
      return this.saveLoading || this.isEdit
    },

    isDisabledUpdateButton (): boolean {
      return !this.selectedConfiguration || this.isEdit
    },

    isDisabledDeleteButton (): boolean {
      return !this.selectedConfiguration || this.isEdit
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | Save | Cancel | null): boolean {
      if(action instanceof Create) {
        return !this.isDisabledInsertButton
      } else if(action instanceof Edit) {
        return !this.isDisabledUpdateButton
      } else if(action instanceof Delete) {
        return !this.isDisabledDeleteButton
      } else if(action instanceof Save) {
        return this.isEdit && !this.saveLoading
      } else if(action instanceof Cancel) {
        return this.isEdit && !this.saveLoading
      } else {
        return false
      }
    },

    onDescriptionLanguagesClick (): void {
      this.showDescriptionLanguagesDialog = true
    },

    onDescriptionLanguagesDialogSave (data: ConfigurationDescriptionLanguage[]): void {
      this.languagesDialogDescriptionData = data
      const foundDescription: ConfigurationDescriptionLanguage | undefined = this.languagesDialogDescriptionData.find((item: ConfigurationDescriptionLanguage) => item.languageId === this.selectedLanguageId)
      this.bezeichnung = foundDescription ? foundDescription.text : null
      this.onDescriptionLanguagesDialogClose()
    },

    onDescriptionLanguagesDialogClose (): void {
      this.showDescriptionLanguagesDialog = false
    },

    onAddConfigurationClick (): void {
      this.isEdit = true
      this.selectedConfigurationIndex = null
      this.selectedConfiguration = null
      //@ts-ignore
      setTimeout(() => {this.$refs.dataGrid.instance.selectRows([])}, 100)

      this.code = null
      this.bezeichnung = null
      this.rtf = false
      const form: any = this.$refs['form']
      form.resetValidation()
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddConfigurationClick()
    },

    onEditConfigurationsClick (): void {
      this.isEdit = true
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditConfigurationsClick()
    },

    onDeleteConfigurationClick (): void {
      this.showDeleteDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteConfigurationClick()
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      this.deleteConfiguration()
    },

    onRowClick (rowData: any): void {
      this.isEdit = false
      this.selectedConfigurationIndex = this.configurationList.indexOf(rowData.data)
      this.selectedConfiguration = rowData.data
      this.setForm()
    },

    onCancelClick (): void {
      this.isEdit = false
      this.setForm()
    },

    cancel (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onCancelClick()
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']

      if (form.validate()) {
        if (this.selectedConfiguration) {
          this.updateConfiguration()
        } else {
          this.createConfiguration()
        }
      }
    },

    save (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onSaveButtonClick()
    },

    createConfiguration (): void {
      console.log('CREATE')
      this.isEdit = false
    },

    updateConfiguration (): void {
      console.log('UPDATE')
      this.isEdit = false
    },

    deleteConfiguration (): void {
      console.log('DELETE')
      this.onDeleteDialogClose()
      this.fetchConfigurationList()
    },

    fetchConfigurationList (): void {
      this.configurationList = this.formData

      this.setForm()
    },

    onResize (): void {
      if(this.$refs.formSection && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.formSection as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 184px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },

    setForm (): void {
      if(!this.selectedConfiguration) {
        if(this.configurationList && this.configurationList[0]) {
          this.selectedConfigurationIndex = 0
          this.selectedConfiguration = this.configurationList[0]

          //@ts-ignore
          setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.configurationList[0].ID])}, 100)
        }
      }

      this.code = this.selectedConfiguration && this.selectedConfiguration.Code ? this.selectedConfiguration.Code : null
      this.bezeichnung = this.selectedConfiguration && this.selectedConfiguration.Bezeichnung ? this.selectedConfiguration.Bezeichnung : null
      this.rtf = this.selectedConfiguration && this.selectedConfiguration.RTF ? this.selectedConfiguration.RTF : false
    }
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
      new Save(KeyActionEnum.save, this.save, this.resolver, null),
      new Cancel(KeyActionEnum.cancel, this.cancel, this.resolver, null),
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)

    this.languagesDialogDescriptionData = this.uiLanguageList.map((item: UiLanguageItem) => {
      return {
        languageId: item.syzId,
        text : ''
      }
    })

    setTimeout(() => { this.onResize() }, 0)
    this.fetchConfigurationList()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
